import React from "react";
import { useParams } from "react-router-dom";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    // // backgroundColor: "#eee",
    // padding: theme.spacing(4),
    height: "100%",
    minHeight: 0,
    minWidth: 0,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  chatPapper: {
    // backgroundColor: "red",
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
    "& > .MuiGrid-container": { flexWrap: "nowrap" },
    [theme.breakpoints.down("sm")]: { "& > .MuiGrid-container": { flexWrap: "wrap" } },
  },

  contactsWrapper: {
    flex: "0 0 360px",
    maxWidth: 360,
    [theme.breakpoints.down("sm")]: { flex: "0 0 100%", maxWidth: "100%" },
    minWidth: 0,
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    flex: "0 0 360px",
    maxWidth: 360,
    minWidth: 0,
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    flex: 1,
    maxWidth: "100%",
    minWidth: 0,
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  emptyMessages: {
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
  welcomeMsg: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    gap: 16,
    padding: 24,
    color: theme.palette.text.secondary,
    background: theme.palette.background.default,
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <div style={{ display: "flex", width: "100%", height: "100%", minWidth: 0 }}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <div
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </div>
          <div className={`${classes.messagessWrapper} ${!ticketId ? classes.emptyMessages : ""}`}>
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* <Paper square variant="outlined" className={classes.welcomeMsg}> */}
                  <ForumOutlinedIcon style={{ fontSize: 64, opacity: .35 }} aria-hidden="true" />
                  <strong style={{ fontSize: 20 }}>Sua central de atendimento</strong>
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
